import React, { useState } from 'react'
import { Button, Glyphicon } from 'react-bootstrap'
import swal from 'sweetalert2'

type Props = { addVendor: Function, closeAddVendorBox: Function }

const AddVendorBox = ({ addVendor, closeAddVendorBox }: Props) => {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [tags, setTags] = useState('')
  const [password, setPassword] = useState('')

  return (
    <div style={{ background: '#fff', marginBottom: 20, padding: 7 }}>
      <input className="change-input form-control" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value.trim())} type="email" />
      <input className="change-input form-control" placeholder="Namn" value={name} onChange={(e) => setName(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Taggar, t.e.x hilti; qilti" value={tags} onChange={(e) => setTags(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Lösenord *" value={password} onChange={(e) => setPassword(e.target.value)} type="text" />
      <Button
        disabled={!email || !password}
        onClick={() => {
          addVendor({
            email,
            name,
            tags: tags.split(';').reduce((acc, t) => {
              const trimmed = t.trim()

              return trimmed ? acc.concat(trimmed) : acc
            }, []),
            password: password && password,
          })
            .then(() => {
              swal.fire({
                type: 'success',
                title: 'Sparat!',
                showConfirmButton: false,
                timer: 1500,
              })
              setEmail('')
              setTags('')
              setPassword('')
              closeAddVendorBox()
            })
            .catch((err) => {
              if (err.isAxiosError) {
                swal.fire({
                  type: 'error',
                  title: err.response.data.message,
                })
              }
              console.log(err)
            })
        }}
        className="btn btn-primary"
        bsSize="small"
        style={{ backgroundColor: '#006e78' }}
        block
      >
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara leverantör
      </Button>
    </div>
  )
}

export default AddVendorBox
